function revealLazyFadeImage(wrapper) {
    const realImg = wrapper && wrapper.querySelector('.real-img');
    const placeholder = wrapper && wrapper.querySelector('.placeholder-img');

    if (!realImg || !placeholder) return false;
    if (!(realImg.complete && realImg.naturalWidth > 0)) return false;
    if (wrapper.__lazyFadeHasFaded) return true;

    wrapper.__lazyFadeHasFaded = true;
    placeholder.classList.add('hide-placeholder');
    realImg.classList.add('show-real');
    return true;
}

function ensureLazyFadeImage(wrapper, forceEager) {
    const realImg = wrapper && wrapper.querySelector('.real-img');
    const placeholder = wrapper && wrapper.querySelector('.placeholder-img');

    if (!realImg || !placeholder) return;

    if (forceEager) {
      try {
        realImg.loading = 'eager';
      } catch (error) {}

      try {
        realImg.decoding = 'async';
      } catch (error) {}
    }

    if (revealLazyFadeImage(wrapper)) {
      return;
    }

    if (!wrapper.__lazyFadeListenersBound) {
      wrapper.__lazyFadeListenersBound = true;

      realImg.addEventListener('load', () => {
        revealLazyFadeImage(wrapper);
      }, { once: true });

      realImg.addEventListener('error', () => {
        wrapper.__lazyFadeHasFaded = false;
        placeholder.classList.remove('hide-placeholder');
        realImg.classList.remove('show-real');
      }, { once: true });
    }
}

function initLazyFadeImages() {
    const lazyImages = document.querySelectorAll('.lazy-fade-image');

    lazyImages.forEach(wrapper => {
      ensureLazyFadeImage(wrapper, false);

      if (wrapper.__lazyFadeInit) return;
      wrapper.__lazyFadeInit = true;

      if (!('IntersectionObserver' in window)) {
        ensureLazyFadeImage(wrapper, true);
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (!entry.isIntersecting) return;

          observer.disconnect();
          setTimeout(() => {
            ensureLazyFadeImage(wrapper, true);
          }, 150);
        },
        { rootMargin: '200px' }
      );

      observer.observe(wrapper);
    });
}

window.forceLoadLazyFadeImages = function (scope) {
  const root = scope && scope.querySelectorAll ? scope : document;

  root.querySelectorAll('.lazy-fade-image').forEach((wrapper) => {
    ensureLazyFadeImage(wrapper, true);
  });
};

// Universal setup for lazy images: Run on load and observe body for mutations (works on all pages like search, collection, etc.)
document.addEventListener('DOMContentLoaded', () => {
  initLazyFadeImages();  // Initial call on page load
});

let lazyInitScheduled = false;
const bodyObserver = new MutationObserver(() => {
  if (lazyInitScheduled) return;
  lazyInitScheduled = true;

  requestAnimationFrame(() => {
    lazyInitScheduled = false;
    initLazyFadeImages();
  });
});

bodyObserver.observe(document.body, { childList: true, subtree: true });

// Collection Card Images Slider (unchanged, as it's already working)
(function () {
  'use strict';
  // Keep track of Swiper instances
  const swiperInstances = {};

  function shouldSkipGlobalSliderInit(slider) {
    return Boolean(slider?.closest('[data-skip-global-product-slider-init="true"]'));
  }

  // Function to initialize sliders
  function initProductSliders(slider) {
    if (!slider || shouldSkipGlobalSliderInit(slider)) {
      return;
    }

    const id = slider.id;
    let initialSlide = 0;
        // Only on Mobile Slide Second Product Images One on Load
    if( window.innerWidth <= 767 ){
        const secondProductCard = document.querySelector('.product-card:nth-child(2)');
        const second_product_id  = secondProductCard && secondProductCard.getAttribute('data-product-id');
        if( second_product_id && 'product-'+second_product_id+'-slider' == id ){
          initialSlide = 2;
        }
    }

    const count = Number(slider.dataset.images_count) || 0;
    console.log('Initializing slider:', id, 'with count:', count);  // Debug log
    if (!id || count === 0) {
      console.log('Skipping slider due to missing id or count');  // Debug log
      return;
    }

    // Destroy old instance if exists
    if (swiperInstances[id]) {
      swiperInstances[id].destroy(true, true);
      delete swiperInstances[id];
    }

    function initThisSwiper() {
      swiperInstances[id] = new Swiper(`#${id}`, {
        initialSlide: initialSlide,
        loop: count > 1,
        slidesPerView: 1,
      //   lazy: true,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2
        },
        preloadImages: false,
        on: {
          init(swiper) {
            if( initialSlide > 0 ){
              setTimeout(() => {
                swiper.slideTo(0);
              }, 1000);
            }
          }
        },
        navigation: {
          nextEl: `#${id} .swiper-button-next`,
          prevEl: `#${id} .swiper-button-prev`,
        },
      });

      slider.addEventListener('mouseleave', () => {
        swiperInstances[id].slideToLoop(0);
      });
    }
    if (document.readyState === 'complete') {
      initThisSwiper();
    } else {
      window.addEventListener('load', initThisSwiper);
    }
  }

  // Observe DOM for AJAX-added sliders
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const sliders = node.querySelectorAll('.product-slider');
          sliders.forEach((slider) => initProductSliders(slider));

          // If the node itself is a slider
          if (node.classList.contains('product-slider')) {
            initProductSliders(node);
          }
        }
      });
    });
  });

  // Start observing body
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial load
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.product-slider').forEach((slider) => initProductSliders(slider));
  });
})();
